import { Injectable } from "@angular/core";
import {throwError as observableThrowError, of as observableOf,  Observable, Subject } from 'rxjs';
import { Http, Response, Headers } from '@angular/http';
import { ConfigService } from "app/@core/config/config.service";
import { map, catchError } from "rxjs/operators";

import * as jwtDecode from 'jwt-decode';
import * as moment from 'moment';
import { environment } from "environments/environment";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";

@Injectable()
export class AuthenticationService {
    baseUrl: string;
    private logoutEventKey = 'logoutEvent';
    private logoutEvent = new Subject<void>();
    private isLoggingOut = false;
    
    constructor(
        protected http: HttpClient,
        protected configService: ConfigService
    ) {
        this.baseUrl = configService.getApiURI();
        window.addEventListener('storage', (event) => {
            if (event.key === this.logoutEventKey) {
                this.destroySession();
            }
        })
    }

    /**
     * Verifica a existência do usuário e suas credenciais, retorna o Token caso autenticado com sucesso.
     * @param username Login do Usuário
     * @param password Senha do Usuário
     * @param recaptchaToken Token desafio reCAPTCHA
     */
    login(username:string, password:string, recaptchaToken: string ) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.baseUrl+'login', {username, password, recaptchaToken}, {headers: headers})
        .pipe(catchError(this.handleError)); 
    }

    private handleError(error: HttpErrorResponse) {
        return observableThrowError(error.message);
    }

    setSession(result) {
        const token = result.headers.get('Authorization');
        const payload = <JWTPayload> jwtDecode(token);
        const user = payload.sub;

        window.localStorage.setItem('access_token', token);
        window.localStorage.setItem('userLogin', user);
        document.cookie = `access_token=${token}`;
    }

    getUserLogin():string{
        const token = localStorage.getItem('access_token');
        const payload = <JWTPayload>jwtDecode(token);
        return payload.sub
    }

    setOrigin(origin: string) {
        window.localStorage.setItem('origin', origin);
    }

    getOrigin() {
        const origin = window.localStorage.getItem('origin');

        return (origin) ? origin : environment.loginRoute;
    }

    getLang() {
        const lang = localStorage.getItem('lang');

        if(lang) {
            if(lang == 'ptbr') {
                return 'pt-br'
            }else{
                return lang;
            }
        }else{
            return 'pt-br'
        }
    }

    setExternalToken(token) {
        const payload = <JWTPayload> jwtDecode(token);
        const user = payload.sub;

        window.localStorage.setItem('access_token', token);
        window.localStorage.setItem('userLogin', user);
        document.cookie = `access_token=${token}`;
    }

    getExpiration() {
        const token = localStorage.getItem('access_token');
        const payload = <JWTPayload>jwtDecode(token);
        const expiresAt = moment.unix(payload.exp);
        return moment(expiresAt);
    }

    isLoggedIn() {
        return moment().isBefore(this.getExpiration());
    }

    getLogoutEvent() {
        return this.logoutEvent.asObservable();
    }

    getToken() {
        if (localStorage.getItem('access_token')) {
            return localStorage.getItem('access_token');
        }

        return null;
    }
    
    async destroySession(params: String = 'cc=true') {
        if (this.isLoggingOut) {
            return
        }
        this.isLoggingOut = true;
        const userLogin = window.localStorage.getItem('userLogin');

        try {
            await this.logout(userLogin);
        } finally {
            this.cleanCache();
            window.location.href = `${environment.loginUrl}${this.getLang()}/${this.getOrigin()}?${params}`;
            localStorage.setItem(this.logoutEventKey, Date.now().toString());
        }    
    }

    cleanCache() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('userLogin');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('userWorkspace');
        localStorage.removeItem('filterLastUsed');
    }

    getHttpHeaders() : HttpHeaders {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.getToken()
        });

        return headers;
    }

    private logout(userLogin: string) {
        return new Promise((resolve, reject) => {
            const requestDate = this.configService.convertDateToIsoString(new Date());
            const _ws = this.configService.webServicesV2['logout'];

            this.http.put(_ws.url(this.baseUrl), { requestDate, userLogin }, { headers: this.getHttpHeaders() })
                .subscribe(result => resolve(true), error => resolve(true));
        })
    }

    // Retirar quando o CORE Application for implementado!
    public getFrotaJSessionId(): Promise<any> {
        return new Promise((resolve, reject) => {
            const _ws = this.configService.webServicesV2['getFrotaJSessionId']

            this.http.get(
                _ws.url(this.baseUrl), { headers: this.getHttpHeaders() }
            ).subscribe(
                result => resolve(result),
                error => reject(error)
            )
        })
    }
    public loginAndGetFrotaJSessionId(password: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const _ws = this.configService.webServicesV2['getFrotaJSessionId']

            this.http.post(
                _ws.url(this.baseUrl), {password: password}, {headers: this.getHttpHeaders()}
            ).subscribe(
                result => resolve(result),
                error => reject(error)
            )
        })
    }

}

interface JWTPayload {
    sub: string;
    exp: number;
}